const addProductToCart = async (event) => {
	event.preventDefault();
	event.stopImmediatePropagation();

	const form = event.target.closest("form");
	const formData = new FormData(form);

	try {
		const isValidated = await window.validate_options(window.hulkapps.product.id);

		if (isValidated) {
			console.log("dobar")
			const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
				method: "POST",
				body: formData,
			});

			if (!response.ok) throw new Error("Network error");

			const product = await response.json();

			if (typeof window.opusOpen === "function") {
				window.opusOpen();
			}
		}
	} catch (error) {
		console.error("Error adding to cart: ", error);
	}
	setTimeout(() => {
 	 window.hulkappsStart($);
	}, 800);

};

document.addEventListener("DOMContentLoaded", () => {
	const submitButton = document.querySelector(".productForm-submit");
	submitButton.addEventListener("click", addProductToCart, { capture: true });
});